/**
 * Converts a Date instance to a string like '04/30/21'.
 * @param date a Date instance
 */
export const dateToTwoDigitDate = (date: Date): string => {
    const formatter = new Intl.DateTimeFormat('en', {
        calendar: 'gregory',
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
    });

    return formatter.format(date);
};
